import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';
import React, { FC } from 'react';

export const Empty: FC<SvgIconProps> = (props) => (
  <SvgIcon fill="none" viewBox="0 0 99 63" {...props}>
    <path
      d="M49.328 62.202c27.243 0 49.328-4.795 49.328-10.71 0-5.915-22.085-10.71-49.328-10.71C22.085 40.781 0 45.576 0 51.491c0 5.915 22.085 10.71 49.328 10.71z"
      fill="#C4C4C4"
      fillOpacity={0.5}
    />
    <path
      d="M84.784 20.524l-15.64-17.6C68.394 1.726 67.297 1 66.143 1H32.516c-1.154 0-2.25.725-3 1.923L13.874 20.525v14.136h70.91V20.524z"
      stroke="#C4C4C4"
    />
    <path
      d="M64.148 25.375c0-2.456 1.532-4.483 3.433-4.484h17.203v27.75c0 3.249-2.035 5.911-4.547 5.911H18.422c-2.512 0-4.547-2.664-4.547-5.91V20.89h17.203c1.9 0 3.433 2.024 3.433 4.48v.033c0 2.456 1.55 4.439 3.448 4.439H60.7c1.9 0 3.45-2.001 3.45-4.457v-.01z"
      fill="#fff"
      stroke="#C4C4C4"
    />
  </SvgIcon>
);

export default Empty;
